var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolationNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4697 0H7.08289V10.3868H17.4697V0Z",
    fill: "#c59d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98002 18.2031H0V24.1831H5.98002V18.2031Z",
    fill: "#c59d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1087 18.2031H9.12872V24.1831H15.1087V18.2031Z",
    fill: "#c59d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18.2031H18.02V24.1831H24V18.2031Z",
    fill: "#c59d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1916 13.6935H12.8277V12.3555H11.5673V13.6935H1.81067V15.2667H2.12348V17.155H3.38388V15.2667H11.5673V17.155H12.8277V15.2667H20.8536V17.155H22.1117V15.2667H22.1916V13.6935Z",
    fill: "#c59d48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.1849,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationNetwork);
export default __webpack_public_path__ + "static/media/isolation-network.bdbb2fed30a61e9bf75e8479da00a079.svg";
export { ForwardRef as ReactComponent };